
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#56CCF2","fill-rule":"evenodd","d":"M43.75 12.32c0 1.71-1.01 3.2-2.48 3.9v7.44c2.92.31 5.24 1.5 5.98 3.03h6.05c8.42 0 15.25 6.76 15.25 15.1 2.7 0 4.9 3.14 4.9 7.02 0 3.87-2.2 7-4.9 7v1.09c0 8.34-6.83 15.1-15.25 15.1H27.15A15.18 15.18 0 0111.9 56.9v-1.08c-2.7 0-4.9-3.14-4.9-7.01 0-3.88 2.2-7.02 4.9-7.02 0-8.34 6.83-15.1 15.25-15.1h5.02c.73-1.53 3.06-2.72 5.98-3.03v-7.2a4.32 4.32 0 01-3.11-4.14A4.34 4.34 0 0139.39 8c2.41 0 4.36 1.93 4.36 4.32zM29.22 37.48a11.87 11.87 0 100 23.73h22.02a11.87 11.87 0 100-23.73H29.22z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#56CCF2","d":"M33.59 48.8a4.34 4.34 0 01-4.36 4.32 4.34 4.34 0 01-4.36-4.31 4.34 4.34 0 014.36-4.32c2.4 0 4.36 1.93 4.36 4.32zm21.99 0a4.34 4.34 0 01-4.36 4.32 4.34 4.34 0 01-4.35-4.31 4.34 4.34 0 014.35-4.32c2.41 0 4.36 1.93 4.36 4.32z"}})])
          )
        }
      }
    